import React from 'react';

export default function CardContainerForm({children}) {
  return (
    <div className="example-card-seamless mb-4-spacing">
      <div>{children}</div>
    </div>
  );
}
